import HomepageAnjo from "features/Anjo";

const Anjo = () => {
  return <HomepageAnjo/>;
};

export default Anjo;
